import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * BlogPromoPreviewComponent
 * Preview page for blog-promo-section entries
 * Routes: /blog-promo or /blog-promo/:entryName
 */
@Component({
  selector: 'app-blog-promo-preview',
  templateUrl: './blog-promo-preview.component.html',
  styleUrls: ['./blog-promo-preview.component.scss'],
  standalone: false
})
export class BlogPromoPreviewComponent implements OnInit {
  apiKey = environment.builderApiKey;
  entryName: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.entryName = params.get('entryName') || '';
    });
  }
}

